import { L10N } from 'global/localization'
import { useSearchParams } from 'react-router-dom'
import { DataHandler } from 'shared/components/data-handler'
import { Empty } from 'shared/components/empty'
import { ErrorContent } from 'shared/components/error-content'
import { Layout } from 'shared/components/layout'
import { Spinner } from 'shared/components/spinner'
import { useBack } from 'shared/services/hooks'
import { useGetTncQuery } from 'store/copyright'
import { setAgreeTnc } from 'store/slices/order'
import { useAppDispatch } from 'store/store'
import { TncFooter } from './footer'

const PACKAGE_QPARAM_KEY = 'p'

export const Tnc = () => {
  const { navigateBack } = useBack()

  const dispatch = useAppDispatch()

  const [searchParams] = useSearchParams()

  const tncData = useGetTncQuery()
  const url = tncData.data?.content

  const agree = () => {
    dispatch(setAgreeTnc(true))

    navigateBack()
  }

  const handleRefetch = () => {
    if (tncData.error) {
      tncData.refetch()
    }
  }

  const renderError = () => {
    return (
      <div className='flex items-center justify-center p-4'>
        <ErrorContent
          title={L10N.MESSAGE.FALLBACK_ERROR_MESSAGE}
          actionText={L10N.LABEL.RELOAD}
          onAction={handleRefetch}
        />
      </div>
    )
  }

  return (
    <Layout title={L10N.LABEL.TERMS_CONDITIONS} noPadding>
      <DataHandler {...tncData}>
        {tncData.error ? (
          renderError()
        ) : tncData.isFetching ? (
          <div className='flex items-center justify-center p-4'>
            <Spinner />
          </div>
        ) : url ? (
          <div className='h-full flex flex-col'>
            <div className='w-full h-full flex-1 bg-gray-100 px-8'>
              <iframe key={Date.now()} src={url} className='h-full bg-white px-2 w-full' />
            </div>
            {searchParams.get(PACKAGE_QPARAM_KEY) ? (
              <div>
                <TncFooter onClick={agree} />
              </div>
            ) : undefined}
          </div>
        ) : (
          <Empty />
        )}
      </DataHandler>
    </Layout>
  )
}
